import ModalViewModel, {
  ModalViewModelClosingSignal,
} from 'infra/ModalViewModel'
import OCRScopingJobMainPanelViewModel from '../../MainPanel/OCRScopingJobMainPanelViewModel'
import { computed } from 'mobx'

/**
 * Modal to confirm the submission of an OCR scope job.
 */
export default class OCRConfirmSubmitModalViewModel extends ModalViewModel {
  constructor(
    public readonly ocrScopingJobMainPanelViewModel: OCRScopingJobMainPanelViewModel,
    closingSignal?: ModalViewModelClosingSignal,
  ) {
    super(closingSignal)
  }

  confirm = async () => {
    await this.ocrScopingJobMainPanelViewModel.submit()
    this.close()
  }

  @computed
  get isBillingRelevant() {
    if (!this.ocrScopingJobMainPanelViewModel.editor.job.owner.isCurrentUser) {
      return false
    }

    return this.ocrScopingJobMainPanelViewModel.editor.submission.billing
      .isBillingRelevant
  }
}
